import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-landingfooter',
  templateUrl: './landingfooter.component.html',
  styleUrls: ['./landingfooter.component.scss'],
})
export class LandingfooterComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
